import { UserType } from '../api/users/index.js';
import type { OptionType } from '../types/OptionType.js';

export const mapUsersToSelect = (list: UserType[]): OptionType[] => {
  return list.map((option: UserType) => ({
    value: option.id as number | string,
    label: `${option.firstName} ${option.lastName}`.trim() || option?.email,
  }));
};
